<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF ALLIED HEALTH SCIENCES</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Medical Lab Technology</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Under Graduate</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">Bachelor of Science in Medical Laboratory Technology</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="row">

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Bachelor of Science in Medical Laboratory Technology
                    (MLT) </b>
                    – The Bachelor of Science in Medical Laboratory Technology (B.Sc. MLT) offered by ARNI School of
                    Allied Health Sciences is a three-year undergraduate program designed to equip students with the
                    knowledge and practical skills required for clinical laboratory diagnostics. This program trains
                    students in analyzing body fluids, conducting laboratory tests, and assisting in disease diagnosis.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b></p>
                <ul>
                    <li> Biochemistry I</li>
                    <li> Human Anatomy I</li>
                    <li> Human Physiology I</li>
                    <li> Health Education & Health Communication</li>
                    <li> PC Software Lab</li>
                    <li> Biochemistry (Lab)</li>
                    <li> Human Anatomy (Lab)</li>
                    <li> Human Physiology (Lab)</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b></p>
                <ul>
                    <li> Health Education & Health Communication</li>
                    <li> Bio-Medical Waste Management</li>
                    <li> Biochemistry II</li>
                    <li> Human Anatomy II</li>
                    <li> Human Physiology II</li>
                    <li> Biochemistry (Lab)</li>
                    <li> Human Anatomy (Lab)</li>
                    <li> Human Physiology (Lab)</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b></p>
                <ul>
                    <li> Clinical Hematology I</li>
                    <li> Immunology & Serology I</li>
                    <li> Pathology I</li>
                    <li> Histopathology & Histotechniques</li>
                    <li> Clinical Hematology - Practical</li>
                    <li> Immunology & Serology - Practical</li>
                    <li> Histopathology & Histotechniques - Practical</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b></p>
                <ul>
                    <li> Clinical Hematology-II</li>
                    <li> Microbiology</li>
                    <li> Pathology – II</li>
                    <li> Histopathology & Histotechniques -II</li>
                    <li> Microbiology, Immunology & Serology</li>
                    <li> Clinical Hematology - Practical</li>
                    <li> Immunology & Serology - Practical</li>
                    <li> Histopathology & Histotechniques - Practical</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 5</b></p>
                <ul>
                    <li> Clinical Enzymology & Automation</li>
                    <li> Diagnostic Cytology</li>
                    <li> Immunohematology & Blood Banking</li>
                    <li> Parasitology & Virology</li>
                    <li> Principles of Lab Management & Medical Ethics</li>
                    <li> Diagnostic Cytology Lab</li>
                    <li> Clinical Enzymology Lab</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 6</b></p>
                <ul>
                    <li> Advanced Diagnostic Techniques</li>
                    <li> Clinical Endocrinology & Toxicology</li>
                    <li> Diagnostic Molecular Biology</li>
                    <li> Advanced Diagnostic Techniques - Practical</li>
                    <li> Clinical Endocrinology & Toxicology - Practical</li>
                    <li> Diagnostic Molecular Biology – Practical</li>
                    <li> Internship/Project</li>
                </ul>
            </div>

        </div>

    </div>
</section>
